import { useTranslate } from "ra-core";

/** Placeholder for an empty, never-required field: « À définir ». */
export const ToDefine = () => {
  const translate = useTranslate();
  return (
    <span className="text-muted-foreground italic">
      {translate("crm.common.to_define")}
    </span>
  );
};
